import React from 'react'

interface Props {
    transform?: string
}

function CircleSVG({ transform }: Props): JSX.Element {
    return (
        <g transform={transform}>
            <defs>
                <filter
                    id="filter0_d"
                    width="149"
                    height="149"
                    x="0"
                    y="0"
                    colorInterpolationFilters="sRGB"
                    filterUnits="userSpaceOnUse"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
                    <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
                    <feOffset dy="4"></feOffset>
                    <feGaussianBlur stdDeviation="3"></feGaussianBlur>
                    <feColorMatrix values="0 0 0 0 0.291667 0 0 0 0 0.291667 0 0 0 0 0.291667 0 0 0 0.25 0"></feColorMatrix>
                    <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
                    <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
                </filter>
                <radialGradient
                    id="paint0_radial"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientTransform="rotate(90 2 72.5) scale(68.5)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#fff"></stop>
                    <stop offset="1" stopColor="#E3E3E3"></stop>
                </radialGradient>
            </defs>
            <g filter="url(#filter0_d)">
                <circle
                    cx="74.5"
                    cy="70.5"
                    r="65.5"
                    fill="url(#paint0_radial)"
                    stroke="#DDDEE1"
                    strokeWidth="6"
                ></circle>
            </g>
            <mask id="mask0" width="137" height="137" x="6" y="2" maskUnits="userSpaceOnUse">
                <circle cx="74.5" cy="70.5" r="68.5" fill="#EEE"></circle>
            </mask>
            <g fillRule="evenodd" clipRule="evenodd" mask="url(#mask0)" opacity="0.8">
                <path
                    fill="#2D77BB"
                    d="M13.87 83.302l-.02.004 120.373 57.139c.004-.002.012-.003.019-.004 49.226-10.654 62.187-32.083 28.949-47.86-33.242-15.778-100.095-19.933-149.322-9.279z"
                ></path>
                <path
                    fill="#92CEFF"
                    d="M134.204 140.449l.019-.004L13.851 83.307c-.005 0-.012.003-.02.003-49.226 10.654-62.187 32.083-28.946 47.861 33.239 15.778 100.092 19.932 149.319 9.278z"
                ></path>
                <path
                    fill="#5C9EE5"
                    d="M155.343 94.28c30.312 14.388 18.495 33.93-26.401 43.647-44.891 9.715-105.861 5.927-136.173-8.462-30.313-14.39-18.495-33.932 26.4-43.648 44.894-9.716 105.862-5.927 136.174 8.462z"
                ></path>
            </g>
        </g>
    )
}

export default CircleSVG
